import { render, staticRenderFns } from "./fileViewer.vue?vue&type=template&id=528b8d3c"
import script from "./fileViewer.vue?vue&type=script&lang=js"
export * from "./fileViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports